import { mapMutations, mapState } from 'vuex';
import FormSwitch from '~/components/Form/FormSwitch';

export default {
  components: {
    FormSwitch,
  },
  data() {
    return {
      priceSetting: {
        description: 'Włącz, jeśli wolisz widzieć w naszym sklepie tylko ceny netto.',
        enabled: false,
        id: 'netPrices',
        label: 'Ceny netto',
        readOnly: false,
      },
      cookieConfig: {
        path: '/',
        maxAge: 60 * 60 * 24 * 30,
      },
    };
  },
  computed: {
    ...mapState({
      acl: state => state.auth.acl,
    }),
  },
  created() {
    if (this.$auth.isLogged()) {
      if (this.acl) {
        this.priceSetting.enabled = this.acl.showNetPrices;
      }
    } else {
      const enabled = this.$cookies.get('netPrices') === 'on';
      this.priceSetting.enabled = enabled;
      this.setAcl({ ...this.acl, showNetPrices: enabled });
    }
  },
  methods: {
    ...mapMutations({
      setAcl: 'auth/setAcl',
    }),
    async onSwitch(name, groupIndex, settingsIndex, event) {
      try {
        if (this.$auth.isLogged()) {
          await this.$axios.$patch(
            `${this.$config.baseOfixApi}/e-commerce/v1/users/current/settings/${name}`,
            {
              newValue: event.target.checked ? 'on' : 'off',
            },
          );
          this.setAcl({ ...this.acl, showNetPrices: event.target.checked });
        } else if (event.target.checked) {
          this.$cookies.set('netPrices', 'on', this.cookieConfig);

          this.setAcl({ ...this.acl, showNetPrices: true });
        } else {
          this.$cookies.set('netPrices', 'off', this.cookieConfig);
          this.setAcl({ ...this.acl, showNetPrices: false });
        }

        this.priceSetting.enabled = this.acl.showNetPrices
          ? this.acl.showNetPrices
          : event.target.checked;
      } catch {
        event.target.checked = !event.target.checked;
      }
    },
  },
};
